import Tether from 'tether';

window.Tether = Tether;



// WEBPACK FOOTER //
// ./src/include/tether.js